"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var Subject_1 = require("rxjs/Subject");
var custom_calculation_service_1 = require("../../../shared/services/api/custom-calculation.service");
var idm_dynamic_forms_controls_1 = require("@synisys/idm-dynamic-forms-controls");
var ValueBindingSettingsComponent = /** @class */ (function (_super) {
    __extends(ValueBindingSettingsComponent, _super);
    function ValueBindingSettingsComponent(communicationService, customCalculationService) {
        var _this = _super.call(this, communicationService) || this;
        _this.communicationService = communicationService;
        _this.customCalculationService = customCalculationService;
        _this._destroy$ = new Subject_1.Subject();
        _this._isReady = false;
        return _this;
    }
    Object.defineProperty(ValueBindingSettingsComponent.prototype, "state", {
        set: function (state) {
            this._state = state;
            this._state['participant0'] = !this._state['participant0'] || this._state['participant0'] === '""' ? null : this._state['participant0'];
            this._state['participant1'] = !this._state['participant1'] || this._state['participant1'] === '""' ? null : this._state['participant1'];
            this._state['participant2'] = !this._state['participant2'] || this._state['participant2'] === '""' ? null : this._state['participant2'];
            this._state['participant3'] = !this._state['participant3'] || this._state['participant3'] === '""' ? null : this._state['participant3'];
            this._state['participant4'] = !this._state['participant4'] || this._state['participant4'] === '""' ? null : this._state['participant4'];
            this._state['participant5'] = !this._state['participant5'] || this._state['participant5'] === '""' ? null : this._state['participant5'];
            this._state['participant6'] = !this._state['participant6'] || this._state['participant6'] === '""' ? null : this._state['participant6'];
            this._state['participant7'] = !this._state['participant7'] || this._state['participant7'] === '""' ? null : this._state['participant7'];
            this._state['participant8'] = !this._state['participant8'] || this._state['participant8'] === '""' ? null : this._state['participant8'];
            this._state['participant9'] = !this._state['participant9'] || this._state['participant9'] === '""' ? null : this._state['participant9'];
        },
        enumerable: true,
        configurable: true
    });
    ValueBindingSettingsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._selectedCustomData = this._state['selectedCustomData'];
        this._availableCustomData = this._state['customData'];
        if (this._state['tooltipSettings']) {
            this._tooltipSettings = idm_ng_controls_1.TooltipSettings.fromJsonString(this._state['tooltipSettings']);
        }
        if (this._state['hint'] !== '') {
            this.hint = idm_dynamic_forms_controls_1.stringToMultilingual(this._state['hint']);
        }
        this.customCalculationService.getCustomCalculations(this.category)
            .subscribe(function (res) {
            if (res.length) {
                if (_this._selectedCustomData) {
                    _this._selectedCustomData = res.find(function (customData) { return customData.key === _this._state['selectedCustomData']['_key']; });
                }
                _this._availableCustomData = res;
                _this._isReady = true;
            }
        });
    };
    ValueBindingSettingsComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    ValueBindingSettingsComponent.prototype.changeCommunicationSettings = function () {
        var data = {
            bindings: {},
            state: this.getState(),
            fields: {}
        };
        this.communicationService.parentSubject.next(new idm_dynamic_controls_metadata_1.CommunicationData(idm_dynamic_controls_metadata_1.CommunicationKey.SETTINGS_CHANGED, data));
    };
    ValueBindingSettingsComponent.prototype.getState = function () {
        return {
            selectedCustomData: this._selectedCustomData,
            participant0: this._selectedCustomData ? this._selectedCustomData.participants[0] : null,
            participant1: this._selectedCustomData ? this._selectedCustomData.participants[1] : null,
            participant2: this._selectedCustomData ? this._selectedCustomData.participants[2] : null,
            participant3: this._selectedCustomData ? this._selectedCustomData.participants[3] : null,
            participant4: this._selectedCustomData ? this._selectedCustomData.participants[4] : null,
            participant5: this._selectedCustomData ? this._selectedCustomData.participants[5] : null,
            participant6: this._selectedCustomData ? this._selectedCustomData.participants[6] : null,
            participant7: this._selectedCustomData ? this._selectedCustomData.participants[7] : null,
            participant8: this._selectedCustomData ? this._selectedCustomData.participants[8] : null,
            participant9: this._selectedCustomData ? this._selectedCustomData.participants[9] : null,
            tooltipSettings: this._tooltipSettings ? this._tooltipSettings.toJsonString() : undefined,
            hint: idm_dynamic_forms_controls_1.multilingualToString(this.hint)
        };
    };
    Object.defineProperty(ValueBindingSettingsComponent.prototype, "isReady", {
        get: function () {
            return this._isReady;
        },
        enumerable: true,
        configurable: true
    });
    ValueBindingSettingsComponent.prototype.onCustomDataSelected = function (customData) {
        this._selectedCustomData = customData;
        this.changeCommunicationSettings();
    };
    Object.defineProperty(ValueBindingSettingsComponent.prototype, "selectedCustomData", {
        get: function () {
            return this._selectedCustomData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValueBindingSettingsComponent.prototype, "availableCustomData", {
        get: function () {
            return this._availableCustomData;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], ValueBindingSettingsComponent.prototype, "category", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], ValueBindingSettingsComponent.prototype, "state", null);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], ValueBindingSettingsComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], ValueBindingSettingsComponent.prototype, "controlLabel", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], ValueBindingSettingsComponent.prototype, "languages", void 0);
    ValueBindingSettingsComponent = __decorate([
        core_1.Component({
            
            selector: 'ejustice-value-binding-settings',
            template: require('./value-binding-settings.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "<ejustice-value-binding-settings\n                    [category]=\"category\"\n                    [state]=\"%{state}\"\n                    [languages]=\"%{languages}\"\n                    [controlLabel]=\"%{controlLabel}\"\n                    [currentLanguageId]=\"%{currentLanguageId}\">\n              </ejustice-value-binding-settings>"
        }),
        __metadata("design:paramtypes", [idm_dynamic_controls_metadata_1.CommunicationService,
            custom_calculation_service_1.CustomCalculationService])
    ], ValueBindingSettingsComponent);
    return ValueBindingSettingsComponent;
}(idm_ng_controls_1.BaseSettings));
exports.ValueBindingSettingsComponent = ValueBindingSettingsComponent;
//# sourceMappingURL=value-binding-settings.component.js.map